module.exports = "dist/images/components-design-separator-control-slant-2.622c736.png";